import { createFileRoute } from '@tanstack/react-router';

// __root.tsx beforeLoad always redirects "/" away based on session, so this
// component never actually renders. Kept as the file-route entry for "/".
export const Route = createFileRoute('/')({
  component: () => null,
});
